import React, {Component} from 'react';
import {Modal, NavBar} from 'antd-mobile';
import './style.less';
const androidqx = require('../../common/image/androidqx.png');
const iosqx = require('../../common/image/iosqx.png');
export default class AgreementModal extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <Modal
                popup
                className="agreementModal"
                visible={this.props.modal}
                // onClose={() => this.props.onClose()}
            >
                <div className="userAgreement">
                    <NavBar
                        className="navBar"
                        mode="light"
                        icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.onClose()} />}
                    >用户协议</NavBar>
                    <div className="contentBox">
                        <div className="title">民途出行用户协议</div>
                        <div className="first">
                            <div>
                                亲爱的旅客，当您预约出行选择民途出行，即表示您已阅读并愿意遵守下列约束性条款，我们会持续关注您的乘车安全和乘车体验。谢谢！
                            </div>
                            <p className="about">一、关于「民途出行」网络预约平台</p>
                            <div>
                                「民途出行」网络预约平台（以下简称“平台”）隶属云南顺佳捷汽车租赁服务有限公司独立研发且拥有自主知识产权的综合性网约车服务平台， 按国家法律法规开展网约车服务，符合《网络预约出租汽车经营服务管理暂行办法》的各项具体要求， 平台业务涵盖了预约出行、机场/高铁接送、专车预约出行、小件物流快递等。平台业务辐射云南、贵州、广西、四川、江西等各州、市、县、乡区域，已形成较为完善的立体交通综合服务平台。
                            </div>
                            <p  className="about">二、关于预约出行</p>
                            <div>
                                1、平台可提供查询、预定、变更及取消行程，开发票等服务。<br/>
                                2、根据网约车监管政策要求，在平台预定成功后方可乘车。<br/>
                                3、平台为乘客提供的网络预约出租汽车出行服务，乘客确认订单，即视为乘客同意与其他同车乘客共同合订此预约出行订单，共同接受平台提供的网络预约出租汽车出行服务。<br/>
                                4、儿童座：<br/>
                                （1）儿童座优惠规则以选座页面为准，不参与活动优惠、积分抵扣；<br/>
                                （2）身高未超过1.1米的小孩视为儿童，可以购买儿童坐；<br/>
                                （3）单趟行程仅可购买一张儿童票；<br/>
                                （4）最后排三个座位可选择儿童票；<br/>
                                （5）如不符合儿童标准购买儿童票的乘客，我们将拒绝提供服务；<br/>
                                （6）如未预定儿童座造成的损失由乘车人自行承担。<br/>
                                5、70岁以上老人和8岁以下儿童需有监护人陪同方可乘车。
                                6、每个座位已包含高额保险：第三者责任险金额100万元，承运人责任险120万/座，乘车人如需额外购买乘客意外险，需另行支付增值服务费。
                            </div>
                            <div className="red">
                                温馨提示：如您预约「民途出行」车辆前，已购买机票、高铁票或火车票，请预留足够的时间，合理安排行程，以免耽误您的出行。
                            </div>
                            <p  className="about">三、关于取消、变更订单规则</p>
                            <div>
                                <div className="smallTit">（一）、取消订单收费标准</div>
                                1、申请取消订单时间距离发车时间超过24小时，不收手续费；<br/>
                                2、申请取消订单时间距离发车时间超过12小时且不足24小时，收取订单金额5%手续费；<br/>
                                3、申请取消订单时间距离发车时间超过2小时且不足12小时，收取订单金额20%手续费；<br/>
                                4、申请取消订单时间距离发车时间不足2小时不可取消订单。<br/>
                                <div className="smallTit">（二）、变更订单收费标准</div>
                                1、申请改签时间距离发车时间超过24小时，不收取手续费；<br/>
                                2、申请改签时间距离发车时间超过12小时且不足24小时，收取订单金额5%手续费；<br/>
                                3、申请改签时间距离发车时间超过2小时且不足12小时，收取订单金额10%手续费；<br/>
                                4、申请改签时间距离发车时间不足2小时不支持改签。<br/>
                                <div className="red">改签须知：低价座位改签到高价座位时须补全差价，高价座位改签到低价座位时不退差价。</div>
                                <div className="smallTit">（三）、特别提示：</div>
                                （1）网上取消订单不提供取消订单凭证！<br/>
                                （2）行程订单距离发车时间不足2小时，确认下单后不支持退、改签；<br/>
                                （3）小数点以后按四舍五入来计算。<br/>
                                <div className="smallTit">（四）、免责申明：</div>
                                 下列情况下，非平台自身原因导致的，本公司不承担违约责任：<br/>
                                （1）因极端天气自然灾害（暴雨，暴雪，台风，地震等）导致车辆不能准时出发的；<br/>
                                （2）因临时修桥、修路、封路等导致车辆不能准时出发的；<br/>
                                （3）因临时限行，限号等导致车辆不能准时出发的；<br/>
                                （4）因其他不可抗力因素或乘客严重违反平台规则导致驾驶员无法正常接送或者车辆不能准时出发的。
                            </div>
                            <p  className="about">四、关于专车预约出行订单</p>
                            <div>
                                1、本平台为乘客提供的专车预约出行服务，乘客选择目的地并确认专车预约订单，即视为乘客同意通过民途出行平台预订专车预约出行服务，视作与平台达成专车预约出行协议。<br/>
                                2、专车预约出行订单的必填信息：乘车人基本信息（姓名、电话）、乘车人数（有婴幼儿、未成年人、残疾人、重症病患者需注明。<br/>
                                3、确认订单后，订单车辆驾驶员会与乘客电话沟通，确认专车预约出行具体信息，包含乘车人数（不超过车辆荷载人数）、接送地点、专车预约形式等（单程、往返、包天）。<br/>
                                4、带货或带宠物需提前与驾驶员及客服沟通确认，在取得同意的情况下方可预订专车预约出行。若不事先沟通取得许可，民途出行驾驶员有权拒绝乘客的预约订单需求，并且不承担乘客的取消订单手续费损失。平台车辆为载人运输车辆，不允许装载超过限定数量的货物，不允许人货混装，否则驾驶员有权拒绝提供服务。
                            </div>
                            <p  className="about">五、关于携带行李须知</p>
                            <div>
                                1、每位乘客允许免费携带25公斤以内体积不大的随身行李，体积不能超过0.25立方米，长度不得超过1米，并以能放置本人座位下或者后备箱内为限。超出规定的部分，平台有权按带货收费，超出部分按1元/公斤收取超重附加费；超过车辆车载范围（以能装后备箱为限）的，平台有权拒绝提供服务。如未备注或未联系客服，一切后果由乘车人自行承担。<br/>
                                2、根据《道路交通安全法》相关规定，以下物品为运输违禁物，请勿携带上车：<br/>
                              （1）易燃、易爆、易腐蚀、有毒、管制刀具、压缩气体、液化气体、生化制品、易感染性、有放射性等危险物品，有强烈刺激性气味、恶臭等异味物品，武器等违法物品，精密仪器等贵重物品，非法出版物、印刷品、音像制品等宣传品；<br/>
                              （2）摩托车、汽车、电动车等车辆使用的蓄电池，额定能量大于100W/H的锂电池或充电宝；<br/>
                              （3）活体动物、尸体、尸骨，如家禽、以及宰杀的各类肉；<br/>
                              （4）没有包装、出处不明的液体和粉末及膏状物品；<br/>
                              （5）烟、酒；<br/>
                              （6）地方性政府规定的临时管制、禁止运输流通的其他物品；<br/>
                              （7）《危险化学品目录》《民用爆炸物品品名表》《易制爆危险化学品名录》《易制毒化学品的分类和品种目录》《中华人民共和国禁止进出境物品表》载明的物品和《人间传染的病原微生物名录》载明的第一、二类病原微生物等，以及法律、行政法规、国务院和国务院有关部门规定禁止寄递的其他物品。
                            </div>
                            <p  className="about">六、关于发票开具规则</p>
                            <div>
                                1、电子发票免费开具，纸质发票收取10元邮寄费用。特殊要求请在发票申请备注内填写说明。<br/>
                                2、三个月以内的订单可以开具发票，超出时间不允开具。<br/>
                                3、行程结束后才可申请开具发票。<br/>
                                4、电子发票在一个工作日内开具，纸质发票在3个工作日内开具并寄出。<br/>
                                5、开票信息填写错误重开规则：<br/>
                              （1）纸质发票：如果纸质发票在当月内开具错误，请在当月内联系客服需要把开错的纸质发票邮寄回我公司，我公司收到后方可重开纸质发票寄回，并且来回运费需要自行承担。如果发票的开票时间已经跨月，则需要收取订单金额10%手续费并承担来回运费；<br/>
                              （2）电子发票：如果电子发票在当月内开具错误，请在当月内联系客服，可以重开，但开错的电子发票需作废。如果发票的开票时间已经跨月，则需要收取订单金额10%手续费；<br/>
                              （3）开票错误超过3个月的公司将不再重开；<br/>
                              （4）重开发票工作人员会在1-3个工作日与你联系，不接受任何急件处理。为了给你带来不必要的麻烦，请开票务必仔细检查你的开票信息及快递信息。
                            </div>
                            <p  className="about"> 七、关于乘车注意事项</p>
                            <div>
                                1、为了乘车安全，乘车人应遵守以下规定，否则，由此产生的一切后果（包括但不限于安全责任和经济后果）由乘车人（或责任人）自行承担：<br/>
                              （1）乘客应在预定时间或与司机约定时间前做好乘车准备，行程途中下车休息应按司机提示准时上车；<br/>
                              （2）乘客不得随意挪动、触碰车内设施，如安全锤、报警装置、监控设备等，不得损坏公司、车内设施或他人财物；<br/>
                              （3）乘车时要坐稳、扶好，系好安全带，不得将头、手、身伸出车外，不准翻越车窗，不准在车内随意走动、打闹，不准向车窗外乱扔杂物，车内全程禁止吸烟，贵重物品随身携带，车未停稳不准上下车，不准随便开启车门；<br/>
                              （4）在车辆行驶过程中，最好不要吃东西，尤其是糖、豆、花生等一类的食品，容易在汽车晃动时呛到气管中；<br/>
                              （5）车辆在安全地带停稳后方可解开安全带下车，下车前应先确定车门后方无安全隐患才可开车门；<br/>
                              （6）乘客不得私自开启后备箱或挪动他人物品。
                            </div>
                            <p  className="about"> 八、关于乘车人随身物品的免责声明：</p>
                            <div>
                                1、对以下部分的损失，本公司不负赔偿责任：<br/>
                              （1）因不可抗力（自然灾害，政府干预，民众骚乱，战争等）或物品本身的性质，乘车人的自身过错，造成物品毁损、灭失；<br/>
                              （2）乘车人自乘车结束服务后24小时内未提出赔偿要求的；<br/>
                              （3）违反限价要求，超过1万元以上的部分；<br/>
                              （4）基于物品可能获得的收益、利润、实际用途、商业机会、商业价值等任何直接、间接损失。<br/>
                                <div className="red">特别提示醒：贵重物品，请随身携带，自行保管，如发生损毁，平台及驾驶员不负赔偿责任。</div>
                            </div>
                            <p  className="about"> 九、关于实名乘车的说明：</p>
                            <div>
                                1、根据国家公安部和网约车相关规范要求，乘车人必须实名，确保乘车人身份信息准确。<br/>
                                2、为了确保乘客的合法权益，请务必在下单时填写真实有效的乘车人身份信息。<br/>
                                3、乘客上车前，驾驶员有权核对乘车人身份信息，发现乘车人信息不一致的，驾驶员有权拒绝乘车人上车，由此导致的损失由乘客自行承担。<br/>
                                4、使用虚假身份信息乘车的平台驾驶员有权拒绝乘客乘车并报公安机关。
                            </div>
                            <p  className="about">十、隐私保护：</p>
                            <div>
                                您使用民途出行平台服务前，需要在民途出行平台创建账号并完善个人资料。通过用户主动提供的方式，我们会收集您的以下信息：<br/>
                                1、您需要向我们提供您的手机号码，并设置您在民途出行平台的用户密码。您还可以通过“微信登录”方式登录民途出行平台，如果您使用“微信登录”，我们还需要获取您在微信平台的OpenID。我们以此识别您在民途出行平台的网络身份，并为您提供民途出行平台服务。如果您拒绝提供手机号码，民途出行平台将无法为您创建账号并提供服务。<br/>
                                2、您可以选择是否提供常用地址（包括家的地址及公司地址），设置常用地址后用户可以更便捷地填入行程起终点信息，提高服务效率。如果您拒绝设置常用地址，则需要您手动输入行程起终点信息。<br/>
                                3、您可以添加紧急联系人，添加紧急联系人时，您可手动输入紧急联系人的姓名、手机号。您添加紧急联系人后，平台会在无法联系到您或发生紧急情况时与紧急联系人联系。<br/>
                                4、行程信息，我们将通过记录用户行为收集您的出发地、到达地、行踪轨迹、时长及里程数信息。我们收集上述信息，是基于法律法规要求以及保护您的人身财产安全、依照平台规则处理用户纠纷之需要。如果您拒绝提供出发地、到达地，将导致平台驾驶员无法为您提供服务。如果您拒绝我们获取您的行踪轨迹，可能导致我们无法获得您的实际行驶路线、无法更好地保护您的权益。<br/>
                                5、录像信息，平台内注册得合法合规车辆可能安装有车内视频记录仪等设备，您使用民途出行平台产品或服务过程中可能被录制视频信息。我们留存上述信息，是基于地方性法律法规要求，或用于用户发生纠纷或安全事故时，核实事实并处理投诉。录像起始时间、保存规则等，以相关法律法规要求为准。<br/>
                                6、 如果您代他人叫车，为方便驾驶员与实际乘车人取得联系，您需要提供实际乘车人的手机号码，并选择填写实际乘车人的姓名、身份信息。如果您拒绝提供实际乘车人手机号码和身份信息，平台将无法提供乘车服务。<br/>
                                7、当您与民途出行客服团队联系时，我们会以通话录音和人工录入的方式记录您的通话信息、意见或建议、姓名、联系方式等，以便我们及时处理纠纷、解决问题或向您反馈结果。如果您拒绝我们收集此类信息，会导致您无法拨打我们的客服电话或客服团队无法将处理结果反馈到您，但不影响您使用民途出行平台核心业务功能。<br/>
                                8、 您使用民途出行平台以上各项功能时，我们还会收集您的以下信息：<br/>
                                （1）位置信息，以便您不需要手动输入地理坐标即可获得相关的服务。在您首次使用民途出行平台前，我们会提示您选择是否允许民途出行平台获取以及何种情况下可以获取您的位置信息。在您使用民途出行平台的过程中，您可以随时通过您的设备设置功能，选择是否允许民途出行平台获取以及何种情况下可以获取您的位置信息。获得您的允许后，我们会通过IP地址、GPS以及能够提供相关信息的其他传感器（如会为民途出行提供附近设备、Wi-Fi接入点和基站信息）来获取您的位置信息。如果您拒绝民途出行平台获取位置信息，您将需要手动定位您的位置。<br/>
                                （2）订单信息及交易状态。我们将记录您的订单信息及交易状态。我们收集上述信息是基于法律法规要求以及保护您的人身财产安全、依照平台规则处理用户纠纷之需要。<br/>
                                （3）您使用上述功能的过程中，通过民途出行平台接打电话、发送短信时，我们会收集您的通话内容、通话时长、主被叫手机号码信息，以及您通过民途出行平台发送的文字信息内容。为更好保护用户安全，民途出行平台不直接向用户提供其他用户的手机号码等联系方式，因此用户只能通过民途出行平台进行通话或信息沟通。我们通过通话录音或客服记录的方式留存上述信息，以便用户发生纠纷或安全事故时，核实事实并处理投诉。如果您拒绝我们获取您的通话信息，可能导致您无法使用民途出行平台的通话及信息功能。
                            </div>
                            <p  className="about">十一、设备权限调用：</p>
                            <div>
                                （1）民途出行平台可能会调用您的一些设备权限，以下是调用权限对应的业务功能、我们调用权限的目的，以及调用权限前向您询问的情况。<br/>
                                （2）您可以在设备的设置功能中选择关闭部分或全部权限，从而拒绝民途出行收集相应的个人信息。使用Android系统的不同设备中，权限显示方式及关闭方式可能有所不同，具体请联系设备及系统开发方。<br/>
                                （3）iOS系统权限调用<br/>
                                <img alt="" src={iosqx}/>
                                （4）Android系统权限调用<br/>
                                <img alt="" src={androidqx}/>
                            </div>
                            <p  className="about">十二、提示：</p>
                            <div>
                                除非你已阅读并接受本须知所有条款，否则你无权使用「民途出行」提供的服务。你使用「民途出行」的服务即视为你已阅读并同意上述须知，且遵守我公司规定。<br/>
                                未尽事宜请拨打24小时服务热线：400-138-9889。
                            </div>

                        </div>
                    </div>
                </div>
            </Modal>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/AgreementModal/index.js